module.exports = __webpack_public_path__ + "img/software.d2efdccb.png";